import { type ClientProfile, kustomerProfileOptions, type Task } from '@cartwheel/api/v1'
import { ClientCard } from '@cartwheel/components'
import { useQuery } from '@tanstack/react-query'
import { trackTaskResourceLink } from './task-analytics'

export function TaskClientCard({ task, client }: { task: Task; client?: ClientProfile }) {
  const clientId = task.client_id
  const kustomerQuery = useQuery({
    ...kustomerProfileOptions({ path: { external_id: clientId ?? '' } }),
    enabled: Boolean(clientId),
    retry: false,
  })

  if (!clientId) return null

  return (
    <ClientCard
      className="mt-4"
      name={client?.name ?? task.resource_name ?? 'Client'}
      schoolName={client?.school_name}
      grade={client?.grade}
      age={client?.age}
      cartwheelHref={client?.portal_url}
      healthieHref={client?.healthie_url}
      kustomerHref={kustomerQuery.data?.url}
      onResourceClick={(destination) => trackTaskResourceLink(task, destination)}
    />
  )
}
